// !!!!!!!DEPRECATED!!!!!!!
// use useClerk hook instead

import {
  ClerkActionType,
  ClerkCategoryType,
} from './types';

// types
type PushPayloads = Record<string, unknown>;

type Payloads = Record<string, boolean | number | string>;

declare const clerkStats: {
  push(params: PushPayloads, force: boolean): void;
  processPageview(obj: PushPayloads): void;
};

enum Action {
  PageView = 'pageview',
  Event = 'event',
}

export class ClerkClient {
  /*
  * The event must be send when user open a new page. We must to send only one
  * event per one open page.
  *
  * sending info:
  *
  *   - referrer: link to the previous page
  *   - url: link to the current page
  * */
   
  public sendPageView = (payload: Payloads = {}) => {
    const params = { ...payload };

    try {
      const vid = window.VID;

      if (!params.controller) {
        params.controller = window.controllerName || 'unknown';
      }

      params.ab_test = window.abTests || '';

      const action = {
        referrer: document.referrer,
        url: document.URL,
      };

      if (vid) {
        params.vid = vid;
      }

      clerkStats.push(
        {
          ...params,
          $: action,
          _: Action.PageView,
        },
        true,
      );
    } catch {
      // do nothing
    }
  };

  /*
  * Method need for sending any event to the analytic store.
  *
  * parameters (Symbol * mean required parameter):
  *
  *   - category*: category of event ClerkCategoryType
  *   - action*: action of event (click, show and etc) ClerkActionType
  *   - payloads: object of any keys with primitive type
  * */
   
  public sendEvent = (
    category: ClerkCategoryType,
    action: ClerkActionType,
    payloads: Payloads = {},
  ) => {
    try {
      const params = {
        ...payloads,
      };
      const vid = window.VID;

      params.ab_test = window.abTests || '';

      if (vid) {
        params.vid = vid;
      }

      clerkStats.push(
        {
          category,
          action,
          ...params,
          _: Action.Event,
        },
        true,
      );
    } catch {
      // do nothing
    }
  };
}
